/**
 * @generated SignedSource<<22e5f1f5d65d95ac3c4051e08cd3f3ba>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type B2ClockSessionPaymentStatus = "COMPLETED" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "%future added value";
export type B2ClockSessionStatus = "AWAITING_PAYMENT" | "CANCELLED" | "RENTAL_ENDED" | "RENTAL_STARTED" | "%future added value";
export type B2ClockSessionEndInput = {
  b2CSessionId: string;
};
export type endRentalPageEndB2CMutation$variables = {
  input: B2ClockSessionEndInput;
};
export type endRentalPageEndB2CMutation$data = {
  readonly b2CLockSessionEnd: {
    readonly finalAmount: number | null | undefined;
    readonly id: string;
    readonly paymentStatus: B2ClockSessionPaymentStatus | null | undefined;
    readonly status: B2ClockSessionStatus;
  };
};
export type endRentalPageEndB2CMutation = {
  response: endRentalPageEndB2CMutation$data;
  variables: endRentalPageEndB2CMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "B2ClockSession",
    "kind": "LinkedField",
    "name": "b2CLockSessionEnd",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finalAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "endRentalPageEndB2CMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "endRentalPageEndB2CMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "478c0009adbfc9c3b91fe445851b76c5",
    "id": null,
    "metadata": {},
    "name": "endRentalPageEndB2CMutation",
    "operationKind": "mutation",
    "text": "mutation endRentalPageEndB2CMutation(\n  $input: B2ClockSessionEndInput!\n) {\n  b2CLockSessionEnd(input: $input) {\n    id\n    status\n    paymentStatus\n    finalAmount\n  }\n}\n"
  }
};
})();

(node as any).hash = "44499a72980c52064f0b424081ab674a";

export default node;
